import { AxiosInstance } from "axios";
import localStorageMethods from "helpers/localStorage";

const withauthorizationInterceptor = (axiosInstance: AxiosInstance) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  axiosInstance.interceptors.request.use((config: any) => ({
    ...config,
    headers: {
      Authorization:`Bearer ${localStorageMethods.getItemFromLocalStorage("accessToken")}`,
    },
  }));
};
export default withauthorizationInterceptor;
